import getWording from "common/utils/wording";
import Icon from "components/Icon/Icon";
import { useTranslation } from "react-i18next";
import { Site } from "types";
import TooltipWrapper from "../TooltipWrapper/TooltipWrapper";

interface IPublicationHeaderSubTitle {
  siteName: string;
  location: string;
  pinned?: boolean;
  otherSites?: Site[];
}

function PublicationHeaderSubTitle({
  siteName,
  location,
  pinned,
  otherSites,
}: IPublicationHeaderSubTitle) {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex flex-col gap-1 items-start">
        <span className="font-bold">{siteName}</span>
        {(otherSites?.length ?? 0) > 0 && (
          <TooltipWrapper
            content={
              <div>
                {otherSites?.map((s) => (
                  <div key={`other-site-${s.id}`}>{s.name}</div>
                ))}
              </div>
            }
          >
            <span className="cursor-pointer text-secondary">
              + {otherSites?.length}{" "}
              {t("forms.site", {
                wording: getWording((otherSites?.length ?? 0) > 1, false),
              })}
            </span>
          </TooltipWrapper>
        )}
      </div>
      {location && <span> | {location}</span>}
      {pinned && (
        <div className="text-sm flex bg-secondary-200 rounded-xl px-2 py-1 ml-1">
          <div className="flex items-center  text-secondary-700">
            <Icon name="TiPinOutline" className="w-4 h-4 mr-1" />
            <span>{t("common.pinned")}</span>
          </div>
        </div>
      )}
    </>
  );
}

export default PublicationHeaderSubTitle;
